import { StaffEmployeeRequest, StaffEmployeeResponse } from "lib-klab-sdks";
import {
  StaffEmployee,
  StaffEmployeeUpsertRequest,
} from "../../../domain/models/employment/employee.model";

export const mapStaffEmployee = (
  source: StaffEmployeeResponse,
): StaffEmployee => ({
  id: source.employeeId,
  identityUserId: source.identityUserId,
  companyId: source.companyId,
  branchId: source.branchId,
  departmentId: source.departmentId,
  positionId: source.positionId,
  countryId: source.countryId,
  cityId: source.cityId,
  geoDepartmentCode: source.geoDepartmentCode,
  geoProvinceCode: source.geoProvinceCode,
  districtCode: source.districtCode,
  leaderEmployeeId: source.leaderEmployeeId,
  code: source.employeeCode,
  documentTypeId: source.documentTypeId,
  documentTypeCode: source.documentTypeCode,
  documentNumber: source.documentNumber,
  firstName: source.firstName,
  lastName: source.lastName,
  secondLastName: source.secondLastName,
  birthDate: source.birthDate,
  gender: source.gender,
  personalEmail: source.personalEmail,
  corporateEmail: source.corporateEmail,
  phoneCountryCode: source.phoneCountryCode,
  phoneNumber: source.phoneNumber,
  address: source.address,
  timezone: source.timezone,
  hiredAt: source.hiredAt,
  photoUrl: source.photoUrl,
  status: source.status,
  createdAt: source.createdAt,
  updatedAt: source.updatedAt,
});

export const mapStaffEmployeeRequest = (
  request: StaffEmployeeUpsertRequest,
): StaffEmployeeRequest => ({
  identityUserId: request.identityUserId,
  companyId: request.companyId,
  branchId: request.branchId,
  departmentId: request.departmentId,
  positionId: request.positionId,
  countryId: request.countryId,
  cityId: request.cityId,
  geoDepartmentCode: request.geoDepartmentCode,
  geoProvinceCode: request.geoProvinceCode,
  districtCode: request.districtCode,
  leaderEmployeeId: request.leaderEmployeeId,
  employeeCode: request.code,
  documentTypeId: request.documentTypeId,
  documentTypeCode: request.documentTypeCode,
  documentNumber: request.documentNumber,
  firstName: request.firstName,
  lastName: request.lastName,
  secondLastName: request.secondLastName,
  birthDate: request.birthDate,
  gender: request.gender,
  personalEmail: request.personalEmail,
  corporateEmail: request.corporateEmail,
  phoneCountryCode: request.phoneCountryCode,
  phoneNumber: request.phoneNumber,
  address: request.address,
  timezone: request.timezone,
  hiredAt: request.hiredAt,
  photoUrl: request.photoUrl,
});
